import AccountStaffChangePasswordForm from './AccountStaffChangePasswordForm.jsx';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';

import { request as updateUser } from '../../../modules/user/actions/change-password';
import { clear as updateUserClear } from '../../../modules/user/actions/change-password';

import decorate from '../../../utils/decorate';

const STATE_KEY = 'admin-user';

function mapStateToProps(state) {
    return {
        user: state.user.get('data', Map()),
        errors: state.user.getIn(['change-password', 'errors'], Map()),
        status: state.user.getIn(['change-password', 'state'])
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onUserUpdateRequest: (old, password) => dispatch(updateUser({old, password})),
        onUserUpdateClear: () => dispatch(updateUserClear())
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    AccountStaffChangePasswordForm
);
